import React from 'react';

const ScrollButtons = (id) => {
    const productBlockSlider = 'product-block-slider-' + id.scrollElementId;
    const productBlock = 'product-block-' + id.scrollElementId;
    const productBlockScroll = 'product-block-scroll-' + id.scrollElementId;
    const productBlockSlideLeft = 'product-block-slide-left-' + id.scrollElementId;
    const productBlockSlideRight = 'product-block-slide-right-' + id.scrollElementId;

    const mobileScrollIndicator = 'mobile-scroll-indicator-' + id.scrollElementId;
    const mobileScrollIndicatorBar = 'bar-' + id.scrollElementId;

    const buttonStyleActive = {
        opacity: 1.0,
        cursor: "pointer"
    }
    const buttonStyleInactive = {
        opacity: 0.2,
        cursor: "auto"
    }

    const scrollWidth = document.getElementById(productBlock).scrollWidth - document.getElementById(productBlock).clientWidth;
    const scrollWidthMobile = document.getElementById(productBlock).scrollWidth;
    const productElementWidth = document.getElementById(productBlockSlider).offsetWidth;
    const hasHorizontalScrollbar = productElementWidth < document.getElementById(productBlock).scrollWidth;

    let currentScrollPosition = 0;

    // Initialize mobile scrollbar indicator position depening on the amount of products to scroll.
    const totalScrollWidth = (productElementWidth / document.getElementById(productBlock).scrollWidth) * 100;
    window.addEventListener("load", () => {
        if (!hasHorizontalScrollbar) {
            document.getElementById(mobileScrollIndicator).style.display = 'none';
        }
        document.getElementById(mobileScrollIndicatorBar).style.width = totalScrollWidth + "%";
    });

    document.getElementById(productBlock).addEventListener("scroll", function() {
        currentScrollPosition = document.getElementById(productBlock).scrollLeft;

        const currentScrollPositionPercent = (currentScrollPosition / scrollWidthMobile * 100);
        document.getElementById(mobileScrollIndicatorBar).style.left = (currentScrollPositionPercent) + "%";

        setButtonStyle();
    });
    
    const setButtonStyle = () => {
        if (currentScrollPosition > 0) {
            for (let i in buttonStyleActive) {
                document.getElementById(productBlockSlideLeft).style[i] = buttonStyleActive[i]
            }
        } else {
            for (let i in buttonStyleInactive) {
                document.getElementById(productBlockSlideLeft).style[i] = buttonStyleInactive[i]
            }
        }
        if (currentScrollPosition < scrollWidth) {
            for (let i in buttonStyleActive) {
                document.getElementById(productBlockSlideRight).style[i] = buttonStyleActive[i]
            }
        } else {
            for (let i in buttonStyleInactive) {
                document.getElementById(productBlockSlideRight).style[i] = buttonStyleInactive[i]
            }
        }
    }

    const ScrollBlockLeft = () => {
        document.getElementById(productBlock).scrollBy({left: -productElementWidth, behavior: 'smooth'})
    }
    const ScrollBlockRight = () => {
        document.getElementById(productBlock).scrollBy({left: productElementWidth, behavior: 'smooth'})
    }

    if (hasHorizontalScrollbar) {
        return (
            <div id={productBlockScroll}>
                <button className={productBlockSlideLeft} id={productBlockSlideLeft} type="button" onClick={() => ScrollBlockLeft()}></button>
                <button className={productBlockSlideRight} id={productBlockSlideRight} type="button" onClick={() => ScrollBlockRight()}></button>
            </div>
        );
    } else {
        return null;
    }

};

export default ScrollButtons;
